import { useContext } from 'react';
import { Checkbox } from '@heroui/checkbox';
import { Popover, PopoverTrigger, PopoverContent } from '@heroui/popover';
import { FeaturesContext } from '@/app/contexts';
import { CheckIcon, XIcon, ToolboxIcon } from '@phosphor-icons/react';
import { useSyncStatus, SyncStatusIndicator } from '@/components/ui/sync-status';
export type { SyncStatus } from '@/components/ui/sync-status';
export function InternalTools() {
  const {
    flagsFromLD,
    featureFlags,
    flagOverrides,
    setFlagOverrides
  } = useContext(FeaturesContext) || {};
  const {
    syncStatus,
    refetch
  } = useSyncStatus(!!featureFlags?.syncStatus);
  const onFlagChange = (key: string, value: boolean) => {
    if (setFlagOverrides) {
      setFlagOverrides({
        ...flagOverrides,
        [key]: value
      });
    }
  };
  return <Popover placement={featureFlags?.enableMediaAndSourceShare ? "top-start" : "bottom-end"} showArrow={true} triggerScaleOnOpen={false} classNames={{
    content: 'flex flex-col justify-start items-start text-gray-900 bg-white p-4 rounded-md max-h-[calc(100vh-150px)] overflow-hidden overflow-x-hidden'
  }} data-sentry-element="Popover" data-sentry-component="InternalTools" data-sentry-source-file="internal-tools.tsx">
      <PopoverTrigger data-sentry-element="PopoverTrigger" data-sentry-source-file="internal-tools.tsx">
        <button type="button" aria-label="Internal Tools" aria-haspopup="dialog" className="bg-transparent border-none p-0 hover:cursor-pointer">
          <ToolboxIcon size={22} weight="duotone" data-sentry-element="ToolboxIcon" data-sentry-source-file="internal-tools.tsx" />
        </button>
      </PopoverTrigger>
      <PopoverContent data-sentry-element="PopoverContent" data-sentry-source-file="internal-tools.tsx">
        <div className="flex flex-col gap-1">
          <div className="flex flex-row items-center justify-between gap-2">
            <h2 className="text-2xl font-bold my-[5px]">Internal Tools</h2>
            {featureFlags?.syncStatus ? <div onMouseEnter={refetch} className="cursor-pointer box-border h-[30px] w-[30px] rounded-full border-[1px] border-solid border-gray-400 flex items-center justify-center">
                <SyncStatusIndicator syncStatus={syncStatus} iconSize={20} fallback={<div className="w-[30px] h-[30px]" />} />
              </div> : <div className="w-[30px] h-[30px]" />}
          </div>
          
          {/* Feature Flags Section */}
          <h3 className="text-lg font-semibold my-[5px]">Feature Flags</h3>
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center justify-between gap-2">
              <div className="font-bold">
                From LD
              </div>
              <div className="font-bold text-right w-[60px] pr-[20px]">
                Current
              </div>
            </div>
            <div className="flex flex-col gap-2 max-w-[calc(100vw-20px)] max-h-[400px] rounded-md bg-slate-900 px-2 py-3 text-white overflow-y-auto custom-scrollbar2">
              {flagsFromLD && Object.keys(flagsFromLD).filter(key => key !== 'powerUserOrg' && (flagsFromLD?.[key] === true || flagsFromLD?.[key] === false)).map(key => <div key={key} className="box-border flex flex-row items-center justify-between gap-1 pb-1 border-b border-solid border-white/30">
                  <div className="flex flex-row items-center gap-1 max-w-[calc(100%-60px)]">
                    <div className="p-1 !cursor-not-allowed">
                      {flagsFromLD?.[key] ? <CheckIcon size={16} className="text-green-500 -mb-1" /> : <XIcon size={16} className="text-red-500 -mb-1" />}
                    </div>
                    <div className={`break-all ${flagsFromLD?.[key] ? 'text-green-500' : 'text-red-500'}`}>{key}</div>
                  </div>
                  <div className="flex flex-row items-center justify-end w-[60px]">
                    <div className="mr-[10px]">
                      <Checkbox onChange={e => onFlagChange(key, e.target.checked)} isSelected={!!featureFlags?.[key]} color={!!featureFlags?.[key] && !!flagsFromLD?.[key] || !featureFlags?.[key] && !flagsFromLD?.[key] ? "success" : "warning"} radius="sm" classNames={{
                    wrapper: `${!featureFlags?.[key] && !flagsFromLD?.[key] ? 'bg-green-500/50' : 'bg-orange-500/50'}`
                  }} />
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>;
}